import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * `/catalogue/games` has no page of its own — the games coverage dashboard
 * lives at `/games` (alongside the existing /games/$id detail + manage
 * pages). This redirect is what the auto-generated breadcrumb under
 * `/catalogue/games/$gameSlug` links back to.
 */
export const Route = createFileRoute("/catalogue/games/")({
	beforeLoad: () => {
		throw redirect({ to: "/games" })
	},
})
